import { HOST_API } from "../../../config-global";
import { Grid, MenuItem, Divider } from "@mui/material";
import {
  RHFRoundedSelect,
  RHFRoundedTextField,
  RHFSwitch,
  RHFUpload,
} from "../../../components/minimal/hook-form";
import { IFormProps } from "types/form-props";
import useApiServices from "api/useApiServices";

interface StepFormProps extends IFormProps {}

const StepForm: React.FC<StepFormProps> = ({ currentItem, setValue }) => {
  const { useGetListApi } = useApiServices();
  const { data: awardsList } = useGetListApi<any>({
    url: `${HOST_API}/api/admin/awards`,
  });

  return (
    <>
      <Grid item xs={12}>
        <RHFRoundedSelect
          name="stepAward"
          size="small"
          label="Award"
          disabled={!!currentItem}
        >
          <MenuItem>None</MenuItem>
          <Divider sx={{ borderStyle: "dashed" }} />
          {awardsList?.items?.map((item: any) => (
            <MenuItem key={item.id} value={item.id}>
              {item.title}
            </MenuItem>
          ))}
        </RHFRoundedSelect>
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField name="title" label="Title (En)" />
      </Grid>
      <Grid item xs={6}>
        <RHFRoundedTextField name="titleAr" label="Title (Ar)" />
      </Grid>
      <Grid item xs={12}>
        <RHFUpload
          name="coverImage"
          onDrop={(acceptedFiles) => {
            const newFile = Object.assign(acceptedFiles[0], {
              preview: URL.createObjectURL(acceptedFiles[0]),
            });
            setValue("coverImage", newFile);
          }}
        />
      </Grid>
      <Grid item xs={6}>
        <RHFSwitch name="published" label="Published" />
      </Grid>
    </>
  );
};

export default StepForm;
